module.exports = function() {
  return new Worker(__webpack_public_path__ + "07da0a3132b9854cbcd7.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./src/app/utils/optimiser/optimise-worker.js
// module id = 620
// module chunks = 1